import { createApi } from '@reduxjs/toolkit/query/react';
import type {
  LegalProfessionalSearchResultDto,
  LegalProfessionalDetailDto,
  LegalProfessionalFilterOptionsDto,
  LegalProfessionalSearchParams,
} from '@/types/legalProfessionals';
import { baseQueryWithRetry } from './baseQuery';
import { TAG_LEGAL_PROFESSIONAL } from '@/store/tagTypes';

export const legalProfessionalsApi = createApi({
  reducerPath: 'legalProfessionalsApi',
  baseQuery: baseQueryWithRetry,
  tagTypes: [TAG_LEGAL_PROFESSIONAL],
  endpoints: (builder) => ({
    searchLegalProfessionals: builder.query<LegalProfessionalSearchResultDto, LegalProfessionalSearchParams | void>({
      query: (params) => ({
        url: '/legal-professionals',
        params: params
          ? {
              ...(params.search && { search: params.search }),
              ...(params.registryNumber && { registryNumber: params.registryNumber }),
              ...(params.type && { type: params.type }),
              ...(params.status && { status: params.status }),
              ...(params.barAssociationId && { barAssociationId: params.barAssociationId }),
              ...(params.city && { city: params.city }),
              page: (params.page ?? 1).toString(),
              pageSize: (params.pageSize ?? 20).toString(),
            }
          : undefined,
      }),
      providesTags: (result) =>
        result?.items
          ? [
              ...result.items.map(({ id }) => ({ type: TAG_LEGAL_PROFESSIONAL, id })),
              { type: TAG_LEGAL_PROFESSIONAL, id: 'LIST' },
            ]
          : [{ type: TAG_LEGAL_PROFESSIONAL, id: 'LIST' }],
    }),
    getLegalProfessionalDetail: builder.query<LegalProfessionalDetailDto, string>({
      query: (id) => `/legal-professionals/${id}`,
      providesTags: (_result, _error, id) => [{ type: TAG_LEGAL_PROFESSIONAL, id }],
    }),
    getLegalProfessionalFilterOptions: builder.query<LegalProfessionalFilterOptionsDto, void>({
      query: () => '/legal-professionals/filters',
    }),
  }),
});

export const {
  useSearchLegalProfessionalsQuery,
  useGetLegalProfessionalDetailQuery,
  useGetLegalProfessionalFilterOptionsQuery,
} = legalProfessionalsApi;
